import {createEntityAdapter} from '@reduxjs/toolkit';
import {ParkingReservation} from '../../data/entities';

export const parkingReservationsAdapter = createEntityAdapter<ParkingReservation>();
